import { getAccountScopeUserConfiguration } from 'mini-common-utils/lib/utils/getAccountScopeUserConfiguration';

export default function getCachedEUEmailPolicyOptInBit() {
    // Get the prime settings
    const primeSettings = getAccountScopeUserConfiguration().PrimeSettings;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    let eUEmailAdsOptions: any;

    if (primeSettings?.Items) {
        for (const primeSetting of primeSettings.Items) {
            if (primeSetting.Id === 'EUEmailAdsOptions') {
                eUEmailAdsOptions = primeSetting.Value?.options?.[0];
                break;
            }
        }
    }

    return eUEmailAdsOptions?.optInBit;
}
